/**
* @desc the ngAddTransferTPL provides support for adding and displaying information of Transfer in Purchase 1
* @example:
* <div ng-booking-page-one request="bkgData.request" flexy="bkgData.bookingRequest.flexyFare" proposal="proposal" passengers="paxAmount" paxname="paxType" paxinfo="bkgData.bookingRequest.paxes" datelastarrival="lastDate" cards="cards" time="newProcess" selection="bkgData.selection"></div>
*/
webClient.directive('ngAddTransfer', ['$window', 'templateService', '$timeout',
    function ($window, templateService, $timeout) {
        var directive = {};
        directive.restrict = 'EA';
        directive.scope = {
            transferinfo: "=",
            margindp: "=",
            transferselectiontype: '=',
            selectedid: "=",
            isoutboundtrain: "=",
            onselecttransfer: "&",
            onunselecttransfer: "&",
            ondetails: "&"
        };
        directive.link = function ($scope, $element) {
            templateService.compile($scope, $element, 'tpl/_AddTransferTPL.html');

            $scope.getTemplateUrl = $window.getTemplateUrl;
            $scope.getDpMarginTransfer = window.$scope.bkgData.getDpMarginTransfer;
            $scope.paxNumber = window.$scope.bkgData.bookingRequest.passengers.length;
            $scope.isValidMargin = $scope.$parent.isValidMargin;
            $scope.getIntPart = $scope.$parent.getIntPart;
            $scope.getDecimalPart = $scope.$parent.getDecimalPart;

            $scope.updateTransferInfos = function () {
                $scope.isSelected = $scope.selectedid === $scope.transferinfo.possibilityId;
                $scope.transferPictoUrl = 'images/products/';
                const transferTypeLowCase = $scope.transferinfo?.transferType?.toLowerCase();
                const vehicleCategoryLowCase = $scope.transferinfo?.vehicle?.category?.toLowerCase();
                const vehicleTypeLowCase = $scope.transferinfo?.vehicle?.type?.toLowerCase();
                if ( vehicleTypeLowCase == "boat" && vehicleCategoryLowCase == "standard") {
                    $scope.transferPictoUrl += "transferts-boat.svg";
                } else if (vehicleTypeLowCase == "boat" && vehicleCategoryLowCase == "prestige") {
                    $scope.transferPictoUrl += "transferts-boat-premium.svg";
                } else if (transferTypeLowCase == "private" && vehicleCategoryLowCase == "standard") {
                    $scope.transferPictoUrl += "transfert-private.svg";
                } else if (transferTypeLowCase == "private" && vehicleCategoryLowCase == "prestige") {
                    $scope.transferPictoUrl += "transfert-private-premium.svg";
                } else {
                    $scope.transferPictoUrl += "transfert.svg";
                }
            }

            $scope.updateTransferPrice = function () {
                if ($scope.isValidMargin($scope.margindp) && $scope.transferinfo) {
                    $scope.isDisplayPriceLoading = false;

                    $scope.transferMarginAmount = 0;
                    $scope.totalTransferPriceWithMargin = 0;

                    $scope.transferinfo.segments.forEach(function (segment) {
                        const segmentPriceNet = segment.price.total;
                        const segmentMarginAmount = window.$scope.bkgData.getDpMarginTransfer(segment.price.total);

                        $scope.transferMarginAmount += segmentMarginAmount;
                        $scope.totalTransferPriceWithMargin += getRoundedValue(segmentPriceNet + segmentMarginAmount);
                    });

                }
            }

            $scope.updateTransferInfos();
            $scope.updateTransferPrice();

            $scope.$watch('transferinfo', function (newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    $scope.updateTransferInfos();
                    $scope.updateTransferPrice();
                }
            });

            $scope.$watch('margindp', function (newValue, oldValue) {
                if ($scope.isValidMargin($scope.margindp) && newValue !== oldValue) {
                    $scope.updateTransferPrice();
                }
            });

            $scope.$watch('selectedid', function () {
                $scope.isSelected = $scope.selectedid === $scope.transferinfo.possibilityId;
            });

            $scope.handleRemovingTransfer = function () {
                $scope.isRemovingTransferLoading = true;
                // Call the parent function and capture its return value (e.g. a Promise).
                const result = $scope.onunselecttransfer();

                if (result && typeof result.finally === 'function') { //Test if the result of $scope.onselect() is a Promise
                    result.finally(() => {
                        $timeout(() => {
                            $scope.isRemovingTransferLoading = false;
                        }, 0);
                    });
                } else {
                    $scope.isRemovingTransferLoading = false;
                }
            };

            $scope.handleAddingTransfer = function () {
                $scope.isAddingTransferLoading = true;
                // Store selected Slide in session storage, if problem adding we remove it later
                const slideElement = document.activeElement.closest('.slick-slide');
                if (slideElement) {
                    const slideIndex = parseInt(slideElement.dataset.slickIndex);
                    if (!isNaN(slideIndex)) {
                        window.sessionStorage.removeItem("slickSelectedTransferSlide_Oneway");
                        window.sessionStorage.removeItem("slickSelectedTransferSlide_Return");
                        window.sessionStorage.setItem("slickSelectedTransferSlide_" + $scope.transferselectiontype, slideIndex);
                    }
                }

                // Call the parent function and capture its return value (a Promise).
                const result = $scope.onselecttransfer();

                if (result && typeof result.finally === 'function') { //Test if the result of $scope.onselect() is a Promise
                    result.finally(() => {
                        $timeout(() => {
                            $scope.isAddingTransferLoading = false;
                        }, 0);
                    });
                } else {
                    $scope.isAddingTransferLoading = false;
                }
            }

            $scope.getFormattedPrice = function (value) {
                if (value != null && typeof value !== 'undefined') {
                    return value.toFixed(2).toString().replace(".", ",");
                } else {
                    return '0,00';
                }
            };
        };
        return directive;
    }
]);
